// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_UnpiP {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--_00000033-shadow);
  z-index: 5000;
}

.containerCustom_oZZ6H {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--_00000033-shadow);
  z-index: 5000;
}

.content_anNLW {
  display: flex;
  flex-direction: column;
  width: 60%;
  max-width: 400px; 
  background-color: var(--white-color);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px var(--_0000001a-shadow);
}

.children_content_jaEZM {
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
  height: 100%;
}

.title_iJJLZ {
  display: flex;
  align-items: center;
  gap: 30px;
  justify-content: space-between;
  width: 100%;
}

.iconTitle_zava2 {
  display: flex;
  align-items: center;
  border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/AddConenctionModal/addConnection.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--_00000033-shadow);\n  z-index: 5000;\n}\n\n.containerCustom {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--_00000033-shadow);\n  z-index: 5000;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  width: 60%;\n  max-width: 400px; \n  background-color: var(--white-color);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px var(--_0000001a-shadow);\n}\n\n.children_content {\n  padding: 24px;\n  width: 100%;\n  box-sizing: border-box;\n  height: 100%;\n}\n\n.title {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.iconTitle {\n  display: flex;\n  align-items: center;\n  border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_UnpiP`,
	"containerCustom": `containerCustom_oZZ6H`,
	"content": `content_anNLW`,
	"children_content": `children_content_jaEZM`,
	"title": `title_iJJLZ`,
	"iconTitle": `iconTitle_zava2`
};
export default ___CSS_LOADER_EXPORT___;
